import { Suspense } from 'react';

import { ClientSideGuard } from '@kc-console/guard';

import FullPageErrorMapper from '../ErrorLayout/FullPageErrorMapper';
import ErrorBoundary from './ErrorBoundary';
import IdleBoundary from './IdleBoundary';

import type { CommonLayoutProps } from '../AppLayout/types';

const AppBoundary = ({ children, pageProps }: CommonLayoutProps) => {
  return (
    <ErrorBoundary fallback={<FullPageErrorMapper />}>
      <Suspense fallback={<></>}>
        <ClientSideGuard pageProps={pageProps}>
          {children}
          <IdleBoundary />
        </ClientSideGuard>
      </Suspense>
    </ErrorBoundary>
  );
};

export default AppBoundary;
